import { buttonVariants } from '@rekrytering/ui/components/button'
import { cn } from '@rekrytering/ui/lib/utils'
import {
  createFileRoute,
  Link,
  Outlet,
  useMatchRoute,
} from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Route as BillingSettingsRoute } from '@/routes/_app/_auth/dashboard/_layout.settings.billing'
import { Route as BrandingSettingsRoute } from '@/routes/_app/_auth/dashboard/_layout.settings.branding'
import { Route as SettingsRoute } from '@/routes/_app/_auth/dashboard/_layout.settings.index'
import { Route as MessageTemplatesSettingsRoute } from '@/routes/_app/_auth/dashboard/_layout.settings.message-templates'
import { Route as NotificationSettingsRoute } from '@/routes/_app/_auth/dashboard/_layout.settings.notifications'
import { Route as OrganisationSettingsRoute } from '@/routes/_app/_auth/dashboard/_layout.settings.organisation'
import { Route as RejectReasonsSettingsRoute } from '@/routes/_app/_auth/dashboard/_layout.settings.reject-reasons'
import { Route as TagsSettingsRoute } from '@/routes/_app/_auth/dashboard/_layout.settings.tags'
import { Route as TeamSettingsRoute } from '@/routes/_app/_auth/dashboard/_layout.settings.team'

export const Route = createFileRoute('/_app/_auth/dashboard/_layout/settings')({
  component: DashboardSettingsLayout,
})

function DashboardSettingsLayout() {
  const { t } = useTranslation()
  const matchRoute = useMatchRoute()
  const isSettingsPath = matchRoute({ to: SettingsRoute.fullPath })
  const isBillingPath = matchRoute({ to: BillingSettingsRoute.fullPath })
  const isOrganisationPath = matchRoute({
    to: OrganisationSettingsRoute.fullPath,
  })
  const isTeamPath = matchRoute({ to: TeamSettingsRoute.fullPath })
  const isNotificationsPath = matchRoute({
    to: NotificationSettingsRoute.fullPath,
  })
  const isBrandingPath = matchRoute({ to: BrandingSettingsRoute.fullPath })
  const isRejectReasonsPath = matchRoute({
    to: RejectReasonsSettingsRoute.fullPath,
  })
  const isTagsPath = matchRoute({ to: TagsSettingsRoute.fullPath })
  const isMessageTemplatesPath = matchRoute({
    to: MessageTemplatesSettingsRoute.fullPath,
  })
  return (
    <div className="flex h-full w-full px-6 py-8">
      <div className="mx-auto flex h-full w-full max-w-(--breakpoint-xl) gap-12">
        <div className="hidden w-full max-w-64 flex-col gap-0.5 lg:flex">
          <Link
            to={SettingsRoute.fullPath}
            className={cn(
              `${buttonVariants({ variant: 'ghost' })} ${isSettingsPath && 'bg-primary/5'}`,
              'justify-start rounded-md',
            )}
          >
            <span
              className={cn(
                `text-sm text-primary/80 ${isSettingsPath && 'font-medium text-primary'}`,
              )}
            >
              {t('settings.tabs.general')}
            </span>
          </Link>
          <Link
            to={BillingSettingsRoute.fullPath}
            className={cn(
              `${buttonVariants({ variant: 'ghost' })} ${isBillingPath && 'bg-primary/5'} justify-start rounded-md`,
            )}
          >
            <span
              className={cn(
                `text-sm text-primary/80 ${isBillingPath && 'font-medium text-primary'}`,
              )}
            >
              {t('settings.tabs.billing')}
            </span>
          </Link>
          <Link
            to={OrganisationSettingsRoute.fullPath}
            className={cn(
              `${buttonVariants({ variant: 'ghost' })} ${isOrganisationPath && 'bg-primary/5'} justify-start rounded-md`,
            )}
          >
            <span
              className={cn(
                `text-sm text-primary/80 ${isOrganisationPath && 'font-medium text-primary'}`,
              )}
            >
              {t('settings.tabs.organisation')}
            </span>
          </Link>
          <Link
            to={TeamSettingsRoute.fullPath}
            className={cn(
              `${buttonVariants({ variant: 'ghost' })} ${isTeamPath && 'bg-primary/5'} justify-start rounded-md`,
            )}
          >
            <span
              className={cn(
                `text-sm text-primary/80 ${isTeamPath && 'font-medium text-primary'}`,
              )}
            >
              {t('settings.tabs.team')}
            </span>
          </Link>
          <Link
            to={BrandingSettingsRoute.fullPath}
            className={cn(
              `${buttonVariants({ variant: 'ghost' })} ${isBrandingPath && 'bg-primary/5'} justify-start rounded-md`,
            )}
          >
            <span
              className={cn(
                `text-sm text-primary/80 ${isBrandingPath && 'font-medium text-primary'}`,
              )}
            >
              {t('settings.tabs.branding')}
            </span>
          </Link>
          <Link
            to={NotificationSettingsRoute.fullPath}
            className={cn(
              `${buttonVariants({ variant: 'ghost' })} ${isNotificationsPath && 'bg-primary/5'} justify-start rounded-md`,
            )}
          >
            <span
              className={cn(
                `text-sm text-primary/80 ${isNotificationsPath && 'font-medium text-primary'}`,
              )}
            >
              {t('settings.tabs.notifications')}
            </span>
          </Link>
          <Link
            to={RejectReasonsSettingsRoute.fullPath}
            className={cn(
              `${buttonVariants({ variant: 'ghost' })} ${isRejectReasonsPath && 'bg-primary/5'} justify-start rounded-md`,
            )}
          >
            <span
              className={cn(
                `text-sm text-primary/80 ${isRejectReasonsPath && 'font-medium text-primary'}`,
              )}
            >
              Reject reasons
            </span>
          </Link>
          <Link
            to={TagsSettingsRoute.fullPath}
            className={cn(
              `${buttonVariants({ variant: 'ghost' })} ${isTagsPath && 'bg-primary/5'} justify-start rounded-md`,
            )}
          >
            <span
              className={cn(
                `text-sm text-primary/80 ${isTagsPath && 'font-medium text-primary'}`,
              )}
            >
              Tags
            </span>
          </Link>
          <Link
            to={MessageTemplatesSettingsRoute.fullPath}
            className={cn(
              `${buttonVariants({ variant: 'ghost' })} ${isMessageTemplatesPath && 'bg-primary/5'} justify-start rounded-md`,
            )}
          >
            <span
              className={cn(
                `text-sm text-primary/80 ${isMessageTemplatesPath && 'font-medium text-primary'}`,
              )}
            >
              Message templates
            </span>
          </Link>
        </div>

        <Outlet />
      </div>
    </div>
  )
}
